jQuery(($) => {
  /**
   * Check if variation is available.
   * This is used if there is multiple attributes.
   * Eg. Red - Small is available. Blue - Small is unavailable.
   * Class gets added if it´s unavailable.
   */
  function checkAvailableVariations(type = 'load') {
    // Get all different attributes. DOM element
    const attributes = $('#sweet-variations-outer').find('.sweet-variations');

    // if there is two attributes or more
    if (attributes && attributes.length >= 1) {
      // Loop trough attributes
      for (let i = 0; i < attributes.length; i += 1) {
        // Get the attribute key eg. pa_color and pa_size.
        const attribute = $(attributes[i]).data('attribute');

        // Get all options from matching core WooCommerce select input
        const selectOptions = $(`select#${attribute} option`);
        const optionValues = [];
        selectOptions.each((index, element) => {
          if ($(element).val() && $(element).val().length) {
            // Push option value to array, if option value is not blank.
            optionValues.push($(element).val());
          }
        });

        // Get all links, this represents the attribute variation
        const sweetLinks = $(attributes[i]).find('.choose-variation');

        // eslint-disable-next-line no-loop-func
        sweetLinks.each((index, element) => {
          const link = element;

          if (type === 'load') {
            link.style.cursor = 'wait';
          }

          const data = {
            post_id: $(element).data('product_id'),
            variation_id: $(element).data('variation_id'),
          };

          // eslint-disable-next-line no-undef
          jQuery.post(translation.ajaxurl, { action: 'maksimer_variable_image_gallery', data }, (response) => {
            link.dataset.galleryHTML = response.main_images;
            link.style.cursor = 'pointer';
          });

          // Check if the attribute still exists in the select option values array
          // Weird stuff. But this is how you check if something is in an array
          if ($.inArray($(element).data('variation'), optionValues) === -1) {
            $(element).addClass('unavailable-option');
          } else {
            $(element).removeClass('unavailable-option');
          }
        });
      }
    }
  }

  $(document).on('click', '.sweet-variations .choose-variation', (event) => {
    event.preventDefault();
    const element = event.currentTarget;

    // Setup data attributes as const
    const attribute = $(element).data('attribute');
    const variation = $(element).data('variation');
    const icon = $(element).data('icon');
    const name = $(element).data('name');
    const description = $(element).data('description');
    const stockStatus = $(element).data('stock_status');
    const galleryHTML = $(element).data('galleryHTML');

    if (!galleryHTML) {
      return;
    }
    // const priceHTML = $('.single_variation_wrap .woocommerce-variation-price');

    // const currentGallery = document.querySelector('#main .product .woocommerce-product-gallery');
    const newGalleryElement = document.createElement('div');
    newGalleryElement.innerHTML = galleryHTML;
    // currentGallery.innerHTML = newGalleryElement.querySelector('.woocommerce-product-gallery').innerHTML;

    $.wc_additional_variation_images_frontend.imageSwap({ main_images: galleryHTML });
    // $.wc_additional_variation_images_frontend.imageSwapOriginal({ main_images: galleryHTML });


    // Remove potential other active item and set clicked to active
    $(element).closest('.sweet-variations').find('.choose-variation.active-option').removeClass('active-option');
    $(element).addClass('active-option');
    $(element).closest('.sweet-variations-outer').find('.chosen-variation').html(`<img src="${icon}" />`);
    $(element).closest('.sweet-variations-outer').find('.chosen-color-label').html(name);
    $(element).closest('.sweet-variations-outer').find('.chosen-color-description').html(description);

    $(element).closest('.product-quick-view').find('ul.checker-points li.stock').html(stockStatus);

    const currentStockStatus = document.querySelector('.buy-area .product-bullet-points-wrapper ul.checker-points li.stock');
    if (currentStockStatus) {
      currentStockStatus.innerText = stockStatus;
    }

    // To the future guy/girl trying to add support for different sizes,
    // I'm sorry I disabled the price update below - 💩
    // if (!$(priceHTML).is(':empty')) {
    //   $('.summary.entry-summary > .price').html(priceHTML);
    // }

    // Get core WooCommerce select input matching clicked attribute variation
    const select = $(`#${attribute}`);

    // Update the selected value to the chosen size
    $(select).val(variation).change();

    // Run check to set includes to unavailable variations
    checkAvailableVariations('click');
  });

  document.body.addEventListener('quick-view-loaded', checkAvailableVariations);

  // Run check to set includes to unavailable variations
  setTimeout(() => {
    checkAvailableVariations();
  }, 600);
});
